import {Component} from '@angular/core';

@Component({
  selector: 'block-temp',
  styles: [`
    :host {
      text-align: center;
      color: #1976D2;
    }
  `],
  template: `
    <div class="block-ui-template">
      <div style="background-color: #f8f5f5;width: 29%;margin: auto;border: 2px solid #590808;color:black;padding-bottom:20px;border-radius:1em">
        <img src="/assets/img/brand/busy.gif">
        <div><strong>{{message}}</strong></div>
      </div>
    </div>
  `
})
export class BlockTemplateComponent { }
